import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import QuizBrowser from "@/pages/QuizBrowser";
import QuizPage from "@/pages/QuizPage";
import ResultsPage from "@/pages/ResultsPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import AuthPage from "@/pages/AuthPage";
import SubscriptionSuccessPage from "@/pages/SubscriptionSuccessPage";
import SubscriptionCancelPage from "@/pages/SubscriptionCancelPage";
import StudyPlanPage from "@/pages/StudyPlanPage";
import AdaptiveQuizPage from "@/pages/AdaptiveQuizPage";
import DictionaryPage from "@/pages/DictionaryPage";
import AdminPage from "@/pages/AdminPage";
import FlashcardsPage from "@/pages/FlashcardsPage";
import PracticeExamGenerator from "@/pages/PracticeExamGenerator";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import InstallPrompt from "@/components/InstallPrompt";

function App() {
  return (
    <div className="min-h-screen bg-background">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/free-quiz" element={<Navigate to="/?quiz=free" replace />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/subscription" element={<AuthPage initialMode="subscribe" />} />
            <Route path="/quizzes" element={<QuizBrowser />} />
            <Route path="/quiz/:quizId" element={<QuizPage />} />
            <Route path="/results" element={<ResultsPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/study-plan" element={<StudyPlanPage />} />
            <Route path="/adaptive-quiz" element={<AdaptiveQuizPage />} />
            <Route path="/dictionary" element={<DictionaryPage />} />
            <Route path="/flashcards" element={<FlashcardsPage />} />
            <Route path="/practice-exam" element={<PracticeExamGenerator />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/subscription/success" element={<SubscriptionSuccessPage />} />
            <Route path="/subscription/cancel" element={<SubscriptionCancelPage />} />
          </Routes>
          <InstallPrompt />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
